interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-[3px]',
};

export default function LoadingSpinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <span
      className={[
        'inline-block rounded-full border-slate-700 border-t-brand-500 animate-spin',
        sizeMap[size],
        className,
      ].join(' ')}
      role="status"
      aria-label="Loading"
    />
  );
}
